import queryString from 'query-string'
import {isString} from 'lodash'
import styles from './Errors.scss'

// @ts-ignore
import {Panel, Item, Headding} from 'components/PrimaryPanel'

const messages: Record<string, string> = {
  employee_info: '手続き申請に必要な必須情報が入力されていません。手続きを申請する前に管理者にお問い合わせください。',
  unemployed: '手続き申請ができません。管理者にお問い合わせください。',
}

export const Errors = () => {
  const error = queryString.parse(location.search)['error']
  if (!isString(error)) return null

  return (
    <div className={styles.errors}>
      <Panel>
        <Headding className={styles.errorHeadding}>エラーメッセージ</Headding>
        <Item>
          <ul>
            <li className={styles.error}>{messages[error]}</li>
          </ul>
        </Item>
      </Panel>
    </div>
  )
}
